import Search from './Search';
import NotificationList from './notification/List';

export const RepairInfoSearch = () => {
  return (
    <>
      <Search />
      <NotificationList />
    </>
  );
};
export default RepairInfoSearch;
